<template>
    <footer>
        <div class="container">
            <span class="copy-right">
            © 2017 Zaidoun Karadsheh. All rights reserved.
                <span class="designed">
                Designed & Developed by <a href="http://mediaplus.com.jo" target="_blank">Media Plus</a>
                </span>
            </span>
            <div class="toTop"></div>
            <div class="email">Email: <a href="mailto:Hello@Zaidounk.com">Hello@Zaidounk.com</a></div>
        </div>
    </footer>
</template>

<script>
export default {
    data () {
        return {
            
        }
    },
    methods: {
    },
    created () {
    }
}
</script>


// WEBPACK FOOTER //
// src/components/sections/Footer.vue